import ApiCore from '../utilities/Core';

export const apiForgot = new ApiCore({
    get: false,
    getSingle: false,
    search: false,
    post: true,
    put: false,
    delete: false,
    url: 'forgot',
    plural: 'forgot',
    single: 'forgot',
});
